import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

import './assets/styles/main.scss';

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ServerError from './components/system/ServerError';
import {loadConfig} from './services/configService';
import Loading from "./layouts/Loading";

const root = ReactDOM.createRoot(document.getElementById('root'));

// قبل از اجرای اپ، لودینگ نشان بده
root.render(<Loading/>);

const init = async () => {
    try {
        await loadConfig();

        const config = window.APP_CONFIG;

        // تغییر عنوان صفحه
        if (config?.title) {
            document.title = config.title;
        }

        // تنظیم توضیحات متا
        if (config?.meta_description) {
            let descTag = document.querySelector('meta[name="description"]');
            if (!descTag) {
                descTag = document.createElement('meta');
                descTag.name = 'description';
                document.head.appendChild(descTag);
            }
            descTag.content = config.meta_description;
        }

        // تغییر رنگ مرورگر (اندروید و...)
        let themeColor = document.querySelector('meta[name="theme-color"]');
        if (!themeColor) {
            themeColor = document.createElement('meta');
            themeColor.name = 'theme-color';
            document.head.appendChild(themeColor);
        }
        themeColor.content = config.theme_color;

        // اضافه کردن متغیرهای CSS سفارشی
        const style = document.createElement('style');
        style.innerHTML = `
      :root {
        --primary-color: ${config.primary_color};
        --secondary-color: ${config.secondary_color};
        --third-color: ${config.third_color};
        --text-color: ${config.title_color};
        --background-color: ${config.background_color};
      }
      .slideshow .swiper .swiper-slide {
  height:  ${config.service_app_settings.slide_height}px !important;
}

      .slideshow .swiper .swiper-slide img {
  height:  ${config.service_app_settings.slide_height}px !important;
}
@media (min-width: 770px) {
      .slideshow .swiper .swiper-slide {
  height:  ${config.service_app_settings.slide_height * 1.5}px !important;
}

      .slideshow .swiper .swiper-slide img {
  height:  ${config.service_app_settings.slide_height * 1.5}px !important;
}
}
.nav-link.active
 {
    color: ${config.primary_color} !important;
    font-weight: 700;
}
.nav-link.active .nav-icon
 {
    color: ${config.primary_color} !important;
    font-weight: 700;
}
    `;
        document.head.appendChild(style);
        const logoUrl = config.logo;

// حذف favicon قبلی
        let oldFavicon = document.querySelector("link[rel='icon']");
        if (oldFavicon) oldFavicon.remove();

// ساخت favicon جدید
        const favicon = document.createElement('link');
        favicon.rel = 'icon';
        favicon.href = logoUrl;
        document.head.appendChild(favicon);

// حذف apple-touch-icon قبلی
        let oldAppleIcon = document.querySelector("link[rel='apple-touch-icon']");
        if (oldAppleIcon) oldAppleIcon.remove();

// ساخت apple-touch-icon جدید
        const appleIcon = document.createElement('link');
        appleIcon.rel = 'apple-touch-icon';
        appleIcon.href = logoUrl;
        document.head.appendChild(appleIcon);
        // اجرای اپ
        root.render(<App/>);
    } catch (error) {
        console.error('APP INIT FAILED:', error);
        root.render(<ServerError/>);
    }
};

init();


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
